var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.04 4.36c.78.77 1.31.24 1.31.24l.98.98a.8.8 0 0 1 0 1.13l-7.22 7.22a.8.8 0 0 1-1.13 0L4 12.95s.53-.53-.24-1.3c-.78-.78-1.31-.25-1.31-.25l-.98-.98a.8.8 0 0 1 0-1.13l7.22-7.22a.8.8 0 0 1 1.13 0l.98.98s-.53.54.24 1.3Zm-6.08 8.36-.01.05.6.6.95-.96L3 8.9l-.96.96.6.6.05-.02c.53-.08 1.11.1 1.64.64.54.53.72 1.1.64 1.64Zm-1.4-4.39 3.5 3.52 5.7-5.7-.59-.6h-.05c-.53.1-1.11-.1-1.64-.63-.54-.53-.72-1.1-.64-1.64l.01-.05-.6-.6-5.7 5.7Zm1.87-.2 3.48-3.49.53.52-3.49 3.48-.52-.52Zm4.7-2.27L6.65 9.34l.52.52 3.49-3.48-.53-.52Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 13.67 13 6l-1-1 2.5-1.5 2 6L15 12l-7 2-1.85-.33Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.23 7.76c.33 1.05 1.05.82 1.05.82l.42 1.32a.8.8 0 0 1-.52 1L5.44 14a.8.8 0 0 1-1-.52L4 12.14s.73-.23.4-1.27c-.33-1.04-1.06-.81-1.06-.81l-.42-1.33a.8.8 0 0 1 .52-1l9.75-3.08a.8.8 0 0 1 1 .52l.42 1.32s-.72.23-.4 1.27Zm-9.25 4.62-.04.04.26.8 1.29-.4-1.5-4.74-1.3.41.26.8.06.02c.5.17.93.6 1.16 1.32.23.72.13 1.32-.2 1.75Zm.77-4.54 1.5 4.74 7.69-2.44-.26-.8-.05-.02c-.51-.17-.94-.6-1.17-1.32-.22-.72-.12-1.31.2-1.74l.03-.05-.25-.8-7.69 2.43Zm1.76.68 4.7-1.49.22.7-4.7 1.5-.22-.71Zm5.22.16-4.7 1.48.23.7 4.7-1.48-.23-.7Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(.4)",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.e351a5d11ef2a60d3cbd5e25585692be.svg";
export { ForwardRef as ReactComponent };